import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import Button from '../components/ui/FitButton';
import { localize } from '../i18n';

export default function SupportPage() {
    const email = 'ebseud6135@gmail.com';
    const mailto = `mailto:${email}?subject=${encodeURIComponent(localize('[집요한약알림] 고객 지원 문의'))}`;
    return <Box sx={{ bgcolor: '#fff', minHeight: '100vh', px: 2.5, py: 3, overflowWrap: 'anywhere' }}>
        <Typography component="h1" sx={{ fontSize: '1.4rem', fontWeight: 800, mb: 2 }}>{localize('집요한약알림 고객 지원')}</Typography>
        <Typography sx={{ lineHeight: 1.8 }}>{localize('앱 이용, 알림, 로그인, 구매·복원에 관한 질문이나 오류를 이메일로 알려주세요. 앱 설치나 로그인 없이 문의할 수 있어요.')}</Typography>
        <Button component="a" href={mailto} fullWidth variant="contained" sx={{ my: 2, minHeight: 48, bgcolor: '#ffe566', color: '#5a4a00', boxShadow: 'none' }}>{localize('이메일로 문의하기')}</Button>
        <Typography sx={{ lineHeight: 1.8 }}>{email}</Typography>
        <Typography component="h2" sx={{ fontSize: '1.1rem', fontWeight: 700, mt: 3, mb: 1 }}>{localize('문의할 때 알려주세요')}</Typography>
        <Typography sx={{ lineHeight: 1.8 }}>{localize('휴대폰·태블릿 모델, OS와 앱 버전, 발생한 문제와 재현 순서를 알려주시면 확인에 도움이 돼요.')}</Typography>
        <Typography sx={{ lineHeight: 1.8, mt: 1 }}>{localize('비밀번호, 인증번호, 로그인 토큰, 약 이름이나 처방전 사진은 보내지 마세요. 화면을 첨부할 때는 개인정보를 가려주세요.')}</Typography>
        <Typography sx={{ lineHeight: 1.8, mt: 2 }}>{localize('의료 상담이나 응급 상황은 의사·약사 또는 현지 응급 기관에 문의해주세요.')}</Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 3 }}>
            <Link href="/health-data" sx={{ display: 'inline-block', py: 1, minHeight: 44, color: '#776000', overflowWrap: 'anywhere' }}>{localize('건강정보 처리 안내')}</Link>
            <Button component="a" href="/privacy" sx={{ minHeight: 44, color: '#776000' }}>{localize('개인정보 처리방침')}</Button>
            <Button component="a" href="/account-deletion" sx={{ minHeight: 44, color: '#776000' }}>{localize('계정 및 데이터 삭제')}</Button>
        </Box>
    </Box>;
}
